<p>{{'STUDENT_APPLICATIONS.code' | translate}}: <span class="code">{{code}}</span></p>
